export default function (dom, opts) {
    let options = {
        eventBtnSel: '.addeventatc',
        ...opts
    }


    const eventButton = Array.from(dom.querySelectorAll(options.eventBtnSel));

    function init() {
    }

    init()

}
